'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Group = require('./Group');

var _Group2 = _interopRequireDefault(_Group);

var style = {
  background: '#fff',
  borderTop: 'solid 1px #e5e5e5',
  borderRight: 'solid 1px #e5e5e5',
  borderLeft: 'solid 1px #e5e5e5',
  fontSize: '10px',
  lineHeight: '1.2',
  overflow: 'auto'
};
var styleItem = {
  padding: '0.3em',
  borderBottom: 'solid 1px #e5e5e5'
};

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.Log',

  propTypes: {
    name: _propTypes2['default'].string.isRequired,
    items: _propTypes2['default'].arrayOf(_propTypes2['default'].string).isRequired
  },

  render: function render() {
    var _props = this.props;
    var name = _props.name;
    var items = _props.items;

    return _react2['default'].createElement(
      _Group2['default'],
      { name: name },
      _react2['default'].createElement(
        'div',
        { style: style, className: 'react-demo__log' },
        items.map(function (x, i) {
          return _react2['default'].createElement(
            'div',
            { key: i, style: styleItem, className: 'react-demo__log-item' },
            x || '<no arguments>'
          );
        })
      )
    );
  }
});
module.exports = exports['default'];